import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledHomeInfoBar = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1000;
  padding: 0 16px;

  &.emarket {
    background-color: ${(props) => props.theme.brand02};
  }

  &.wholesale {
    background-color: ${(props) => props.theme.wholesale};
  }

  .market-tag {
    position: absolute;
    left: 51px;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${(props) => props.theme.white};
    color: ${(props) => props.theme.black};
    font-size: 13px;
    font-weight: 500;
    padding: 4px 14px;
    border-radius: 30px;
    line-height: 1;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
  }

  span {
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => props.theme.white};
  }

  .home-info-products {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: ${(props) => props.theme.white};
  }

  .home-info-site {
    display: inline-flex;
    align-items: center;
    gap: 6px;

    a {
      color: ${(props) => props.theme.white};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .home-info-products img,
  .home-info-site img {
    width: 16px;
    height: 16px;
  }

  .separator {
    opacity: 0.6;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: none;
  }
`;
